export default "__VITE_ASSET__ClqP8C5U__ 402w";